import { useState, useEffect, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { refetchDashboardDataRequest } from '../store/dashboards/actions';

const refreshRates = [
  { value: '30s', title: '30s' },
  { value: '1m', title: '1m' },
  { value: '3m', title: '3m' },
  { value: '5m', title: '5m' },
  { value: '10m', title: '10m' },
  { value: '15m', title: '15m' },
  { value: '30m', title: '30m' },
  { value: '1h', title: '1h' },
];

const useRefreshTimeout = () => {
  const dispatch = useDispatch();
  const [intervalGroups, setIntervalGroups] = useState(() => {
    const groups = {};
    refreshRates.forEach(rate => {
      groups[rate.value] = [];
    });
    return groups;
  });

  const addItemToGroup = useCallback((item, refreshRate) => {
    setIntervalGroups(prevGroups => {
      const newGroups = { ...prevGroups };
      newGroups[refreshRate].push(item);
      return newGroups;
    });
  }, []);

  const removeItemFromGroup = useCallback((item, refreshRate) => {
    setIntervalGroups(prevGroups => {
      const newGroups = { ...prevGroups };
      newGroups[refreshRate] = newGroups[refreshRate].filter(i => i.id !== item.id);
      return newGroups;
    });
  }, []);

  const moveItemBetweenGroups = useCallback((item, currentRate, newRate) => {
    setIntervalGroups(prevGroups => {
      const newGroups = { ...prevGroups };
      newGroups[currentRate] = newGroups[currentRate].filter(i => i.id !== item.id);
      newGroups[newRate].push(item);
      return newGroups;
    });
  }, []);

  const refetchItems = useCallback((group) => {
    dispatch(refetchDashboardDataRequest(group));
  }, [dispatch]);

  useEffect(() => {
    const intervals = {};

    refreshRates.forEach(rate => {
      const interval = rate.value;
      let intervalMs;

      switch (interval) {
        case '30s':
          intervalMs = 30 * 1000;
          break;
        case '1m':
          intervalMs = 60 * 1000;
          break;
        case '3m':
          intervalMs = 3 * 60 * 1000;
          break;
        case '5m':
          intervalMs = 5 * 60 * 1000;
          break;
        case '10m':
          intervalMs = 10 * 60 * 1000;
          break;
        case '15m':
          intervalMs = 15 * 60 * 1000;
          break;
        case '30m':
          intervalMs = 30 * 60 * 1000;
          break;
        case '1h':
          intervalMs = 60 * 60 * 1000;
          break;
        default:
          intervalMs = 0;
      }

      if (intervalMs > 0) {
        intervals[interval] = setInterval(() => {
          if (intervalGroups[interval].length > 0) {
            refetchItems(intervalGroups[interval]);
          }
        }, intervalMs);
      }
    });

    return () => {
      Object.values(intervals).forEach(clearInterval);
    };
  }, [intervalGroups, refetchItems]);

  return { addItemToGroup, removeItemFromGroup, moveItemBetweenGroups };
};

export default useRefreshTimeout;